import type { Currency } from './CurrenciesApiService';
import { useCurrenciesQuery } from './CurrenciesQuery';

interface HookResult extends Omit<ReturnType<typeof useCurrenciesQuery>, 'data'> {
    data: Currency[];
}

export const useCurrencies = (): HookResult => {
    const { data, ...rest } = useCurrenciesQuery();

    return {
        ...rest,
        data: data?.fx || [],
    };
};
